<div *ngIf="hasProfileSet">
    <router-outlet></router-outlet>
</div>
